
import { RolesClientWrapper } from './RolesClientWrapper';

export default function Page() {
    return (
        <div>
            <RolesClientWrapper initialData={[]} pagination={undefined} />
        </div>
    );
}